// components/protectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import LoadingOverlay from "../ui/LoadingOverlay";

const ProtectedRoute = ({ children, allowWithout2FA = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingOverlay />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowWithout2FA && !user.two_fa_enabled) {
    return <Navigate to="/setup-2fa" replace />;
  }

  return children;
};

export default ProtectedRoute;
